import 'dayjs/locale/es';
import dayjs from 'dayjs';
import { at } from 'lodash';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

interface DatePickerEditFieldProps {
  label: string;
  name: string;
  [key: string]: any;
}

function DatePickerEditField(props: DatePickerEditFieldProps) {
  const [field, meta] = useField(props.name);
  const formikProps = useFormikContext<any>();
  const { label, ...otherProps } = props;

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
    return '';
  }

  const fieldValue = formikProps.values[field.name];
  const dateValue = fieldValue ? dayjs(fieldValue) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <DatePicker
        {...otherProps}
        label={label}
        value={dateValue}
        onChange={(value) => {
          formikProps.setFieldValue(field.name, value ? value.format('YYYY-MM-DD') : null);
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            error: meta.touched && Boolean(meta.error),
            helperText: _renderHelperText(),
          },
        }}
      />
    </LocalizationProvider>
  );
}

DatePickerEditField.defaultProps = {
  label: '',
  name: '',
  views: ['year', 'month', 'day'],
};

DatePickerEditField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default DatePickerEditField;
